import Vue from "vue";
import Vuex from "vuex";
//import axios from "axios";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    dash: null,
    results: null,
    pagination: null,
    statusId: null,
    orderBy: null,
    orderAsc: null,
    search: null,
    page: 0,
    pageSize: 10,
    totalResults: null,
    record: null,
    listUpdated: false
  },
  mutations: {
    SET_DASH(state, payload) {
      state.dash = payload;
    },
    SET_RESULTS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
      state.page = payload.pagination.page;
      state.pageSize = payload.pagination.pageSize;
      state.totalResults = payload.pagination.totalResults;
    },
    SET_STATUS_ID(state, payload) {
      state.statusId = payload;
    },
    SET_ORDER_BY(state, payload) {
      state.orderBy = payload;
    },
    SET_ORDER_ASC(state, payload) {
      state.orderAsc = payload;
    },
    SET_SEARCH(state, payload) {
      state.search = payload;
    },
    SET_PAGE(state, payload) {
      state.page = payload;
    },
    SET_RESET_PAGE(state, payload) {
      state.page = 0;
    } /*
    SET_PAGE_SIZE(state, payload) {
      state.pageSize = payload;
      state.page = 1; //reset page on page size change
    },*/,
    SET_RECORD(state, payload) {
      state.record = payload;
    },
    SET_LIST_UPDATED(state, payload) {
      state.listUpdated = payload;
    }
  },
  actions: {
    //PRE: you can send payload.params to override and set params
    //     at call time. Otherwise it uses the params previously set.
    async load({ commit }, payload) {
      try {
        //console.log("userStore: user data stored");
        const x = 10;
        const res = await Vue.prototype.$axios.get(`/payment-links`, {
          params: {
            statusId: this.state.paymentLinks.statusId || 1,
            orderBy: this.state.paymentLinks.orderBy || "",
            orderAsc: this.state.paymentLinks.orderAsc || "",
            page: this.state.paymentLinks.page + 1,
            pageSize: this.state.paymentLinks.pageSize,
            search: this.state.paymentLinks.search || ""
          }
        });
        if (res.status != 200) {
          commit("SET_RESULTS", {
            results: null,
            pagination: {
              page: 0,
              pageSize: this.state.paymentLinks.pageSize,
              totalResults: null
            }
          });
          throw errors.handleHTTPError(res);
        }
        if (res.data.results.length > 0) {
          commit("SET_RESULTS", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadDash({ commit }, payload) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/payment-links/dash`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        if (res.data) {
          commit("SET_DASH", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadOne({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/payment-links/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_RECORD", res.data);
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    async save({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.put(
          `/payment-links/${params.id}`,
          params
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_RECORD", res.data);
        return res.data.id;
      } catch (error) {
        throw error;
      }
    },
    async add({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.post("/payment-links", {
          name: params.name,
          description: params.description,
          amount: params.amount,
          endDate: params.endDate,
          costCenterERPCode: params.costCenterERPCode,
          businessUnitId: params.businessUnitId,
          productId: params.productId
        });
        if (res.status != 201) {
          const x = 10;
          throw errors.handleHTTPError(res);
        }

        commit("SET_RECORD", res.data);
        return res.data.id;
      } catch (err) {
        const y = 10;
        throw err;
      }
    },
    async delete({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.delete(`/payment-links/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        throw error;
      }
    },
    async sell(
      { commit },
      { paymentFormPayload, customerFormPayload, linkToken, paymentLinkId }
    ) {
      try {
        const x = 10;
        const res = await Vue.prototype.$axios.post(
          `/payment-links/${paymentLinkId}/sell`,
          {
            firstName: customerFormPayload.firstName || null,
            lastName: customerFormPayload.lastName || null,
            email: customerFormPayload.email,
            phone: customerFormPayload.tel || null,
            DNI: customerFormPayload.DNI || null,
            linkToken,
            cardToken: paymentFormPayload.tempCardToken,
            paymentCourierId: paymentFormPayload.paymentCourierId,
            cardSecurityCode: paymentFormPayload.CVC,
            cardBin: paymentFormPayload.bin,
            lastFourDigits: paymentFormPayload.lastFourDigits,
            expirationDate: paymentFormPayload.expirationDate,
            cardName: paymentFormPayload.cardName,
            cardDNI: paymentFormPayload.cardDNI,
            installments: paymentFormPayload.installments
          }
        );
        if (res.status != 201) {
          const err = errors.handleHTTPError(res);
          throw err;
        }
        const z = 10;
        return res.data;
      } catch (err) {
        throw err;
      }
    },
    async generateLinkToken({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.get(`/payment-links/${id}/link`);
        if (res.status != 200) throw errors.handleHTTPError(res);

        return res.data.linkToken;
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    paymentLinks: state => {
      const paymentLinks = {
        dash: state.dash,
        results: state.results,
        pagination: state.pagination,
        statusId: state.statusId,
        orderBy: state.orderBy,
        search: state.search,
        page: state.page,
        pageSize: state.pageSize
      };
      return paymentLinks;
    },
    listUpdated: state => {
      return state.listUpdated;
    }
  }
};
